export default __webpack_public_path__ + "_/images/app/telegram/telegram-ru-2-683fade63e450db80a530c6267c6b74d77f3f081a50a76f95841c2febfda4bb6.jpg";